import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';
import { strollersPrefix } from 'mk2/apps/strollers/urls';

export const WIKI_REVIEWS_ARTICLE_SLUG = WIKI_CATEGORIES.filter((wc) => wc.id === 13)[0].slug;
export const WIKI_EXPERIENCE_MENU_MORE = (id: number) => `wiki-experience-menu-more-${id}`;
export const isFaq = (categorySlug: string) => categorySlug === 'faq';
export const isStrollers = (categorySlug: string) => categorySlug === strollersPrefix;
export const isReviewArticle = (categorySlug: string) => categorySlug === WIKI_REVIEWS_ARTICLE_SLUG;
export const isReviewHomepage = (categorySlug: string, articleSlug: string) =>
    categorySlug === WIKI_REVIEWS_ARTICLE_SLUG &&
    articleSlug === WIKI_REVIEWS_ARTICLE_SLUG;

export const getAverageRating = (experiences, round = true) => {
    let sum = 0;
    let ratedExp = 0;
    for (let i = 0; experiences.length > i; i++) {
        if (experiences[i].starsCount) {
            ratedExp += 1;
            sum += experiences[i].starsCount;
        }
    }
    return round ? Math.round(sum / ratedExp) : sum / ratedExp;
};

